/* eslint-disable import/no-duplicates */
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { GraphData } from 'entities/GraphData';
import { MetricTypeEnum } from 'enums/MetricTypeEnum';
import formatNumber from './formatNumber';

interface ObjectDatas {
  hour?: string;
  value?: string;
}

export interface AvailableDatas {
  date?: string;
  values?: ObjectDatas[];
}

export interface DataDays {
  hour: string;
  value?: string;
}

export interface Data {
  dates: AvailableDatas[];
  hours?: string[];
}

const OrderData = (data: string[]) => {
  const formattedHours = data.sort((a, b) => {
    const [hoursA, minutesA] = a.split(':').map(Number);
    const [hoursB, minutesB] = b.split(':').map(Number);

    if (hoursA === hoursB) {
      return minutesA - minutesB;
    }

    return hoursA - hoursB;
  });

  return formattedHours;
};

export function evolutionFormat(data: GraphData[]) {
  const availableDates: AvailableDatas[] = [];

  const days = [
    ...new Set(
      data.map((item) =>
        format(new Date(item.mensuramentDate), 'd MMMM', { locale: ptBR }),
      ),
    ),
  ];

  const hours = [
    ...new Set(
      data.map((item) =>
        format(new Date(item.mensuramentDate), 'HH:00', { locale: ptBR }),
      ),
    ),
  ];

  for (let i = 0; i < days.length; i++) {
    const day = days[i];
    const daysData: DataDays[] = [];

    for (let j = 0; j < hours.length; j++) {
      const hour = hours[j];
      let result = '-';

      const valueDate = data.find(
        (date) =>
          format(new Date(date.mensuramentDate), 'd MMMM', { locale: ptBR }) ===
            day &&
          format(new Date(date.mensuramentDate), 'HH:00', { locale: ptBR }) ===
            hour,
      );

      if (valueDate) {
        if (valueDate.metricType === MetricTypeEnum.BLOOD_PREASSURE) {
          result = `${valueDate.hightPressure}|${valueDate.lowPressure}`;
        } else {
          const value = Object.values(valueDate).find(
            (item) => typeof item === 'number',
          );

          // Uma casa: a temperatura chega do sensor como float de 32 bits
          // (`35.599998474121094`), e a tabela a mostrava crua.
          result = typeof value === 'number' ? formatNumber(value, 1) : '-';
        }
      }

      const hourObj = { hour, value: result };

      daysData.push(hourObj);

      daysData.sort((a, b) => {
        const [hoursA, minutesA] = a.hour.split(':').map(Number);
        const [hoursB, minutesB] = b.hour.split(':').map(Number);

        if (hoursA === hoursB) {
          return minutesA - minutesB;
        }

        return hoursA - hoursB;
      });
    }
    availableDates.push({ date: day, values: daysData });
  }

  const dataDays: Data = { dates: availableDates, hours: OrderData(hours) };

  return dataDays;
}
